var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLabel = function SvgLabel(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#1C57B5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.7,
    d: "M13.605 7.354 9.087 2.836c-.309-.308-.463-.463-.643-.573a1.8 1.8 0 0 0-.516-.214C7.723 2 7.504 2 7.068 2H4.68M2.896 5.986V7.16c0 .291 0 .437.033.574q.045.183.143.344c.073.12.176.223.382.429l4.64 4.64c.471.47.707.707.979.795.239.077.496.077.735 0 .272-.088.507-.324.978-.795l1.473-1.472c.47-.472.706-.707.795-.979a1.2 1.2 0 0 0 0-.735c-.089-.272-.324-.507-.796-.979L7.917 4.64c-.206-.206-.309-.309-.429-.383a1.2 1.2 0 0 0-.344-.142c-.137-.033-.282-.033-.573-.033H4.8c-.666 0-1 0-1.254.13a1.2 1.2 0 0 0-.52.52c-.13.254-.13.587-.13 1.254"
  })));
};
export default SvgLabel;